import { InjectionToken } from '@angular/core';
import { ApiService } from '@lsq-frontend/angular-shared/api-service';
import { ISha } from '../models/common';
import { Atlas } from '../routing/atlas/atlas';

export const CLAIMS = new InjectionToken<any>('CLAIMS');
export const FORGOT_PASSWORD_SERVICE = new InjectionToken<ApiService<any, any>>(
    'FORGOT_PASSWORD_SERVICE'
);
export const SEND_PHONE_NUMBER_VERIFICATION_CODE_SERVICE = new InjectionToken<ApiService<any, any>>(
    'SEND_PHONE_NUMBER_VERIFICATION_CODE_SERVICE'
);
export const VALIDATE_PHONE_NUMBER_VERIFICATION_CODE_SERVICE = new InjectionToken<
    ApiService<any, any>
>('VALIDATE_PHONE_NUMBER_VERIFICATION_CODE_SERVICE');

export const SHA = new InjectionToken<ISha>('SHA');
export const ATLAS = new InjectionToken<Atlas>('ATLAS');
export const ModalServiceToken = 'ModalServiceSingleToken';
